var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('span',{staticClass:"datetime"},[_vm._v(_vm._s(_vm._f("moment")(_vm.data,_vm._format)))]):(_vm.humanize)?_c('span',{staticClass:"datetime"},[_vm._v(_vm._s(_vm._f("duration")(_vm.data,'humanize', true)))]):(_vm.calendar)?_c('span',{staticClass:"datetime"},[_vm._v(_vm._s(_vm._f("moment")(_vm.data,'calendar')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }